










































import Scope from '@/views/atoms/Scope.vue'
import PopupCircleEpisode from '@/views/templates/africadogs/PopupCircleEpisode.vue'

export default
  components: {
    Scope
    PopupCircleEpisode
  }

  data: () ->
    title: [
      [
        '<strong>アート・ユニ</strong>の'
        'すごいところ その2'
      ]
      [
        '<strong>アート・ユニ</strong>の'
        'すごいところ その1'
      ]
      [
        '<strong>アート・ユニ</strong>の'
        'すごいところ その3'
      ]
      [
        '<strong>アート・ユニ</strong>の'
        'すごいところ その4'
      ]
      [
        '<strong>アート・ユニ</strong>の'
        'すごいところ その5'
      ]
    ]
    subtitle: [
      [
        'シルクスクリーンから'
        '手描き染めまで幅広く対応'
      ]
      [
        '23mの布を手で染めるアート・ユニは'
        '世界的にも稀な工房'
      ]
      [
        '色に厳しいアパレルメーカーも絶賛'
        '狙った色を再現する西田さんの染料合わせ'
      ]
      [
        'パリのコレクションにも使用される'
        '洗練された高い染色技術'
      ]
      [
        '厳しい染色職人の世界に飛び込んだ'
        '弟子の越本くん'
      ]
    ]
    message: [
      [
        '西田さんの工房には、およそ4,000枚のシルクスクリーンがずらっと並んでいます。その姿はまさに圧巻！'
        '柄や模様をあらかじめ製作したパターンの中から選んで布にあて、染料を塗っていくシルクスクリーンは、微妙な力具合で塗り斑が出てしまうこともあるそう。'
        'さらにシルクスクリーンだけでなく「手描き」でも染めることができる、世界的にも稀な工房です。'
      ]
      [
        '京都の染色工房は大きくわけて2つのパターンがあります。'
        '一反が13mほどの、「小幅（こはば）」という着物に使われる反物を染める工房と、23mほどの「広幅（ひろはば）」という洋服やインテリアに使われる反物を染める工房があります。'
        '西田さんは「広幅」を取り扱っていますが、着物産業で栄えた京都は圧倒的に「小幅」が多く、広い場所が必要となる「広幅」を手で染めることができる工房は希少です。'
      ]
      [
        '染色工程で、専門的かつ高度な知識を必要とする「染料合わせ」は、専門の職人さんを雇い入れるのが一般的ですが、アート・ユニでは西田さん自身が手がけています。'
        '「染料合わせ」は0.01ｇ単位で染料を調合し、湿気や気候によって微妙に分量を変える繊細な仕事です。'
        'アパレルメーカーからの色に対する高い要求にもしっかり応え、満足してもらえる作品を提供するのが自分たちの仕事！とのこと。'
      ]
      [
        '西田さんは半世紀近いキャリアに裏付けられた経験則を総動員して、数々の「ヨソではできない」技法を編み出しています。'
        'ろうけつ染め風の独特の割れ模様が特徴的な「彩纈染め（さいけつぞめ）」や「ぼかし染め」といった、機械では生み出せない繊細な表情をもつ作品がその代表作です。'
        '西田さんの染色技術は、パリのコレクションブランドが採用するほど。それだけ洗練された高い技術がアート・ユニの魅力です。'
      ]
      [
        '西田さんの弟子として、越本くんがアート・ユニに加わりました。染色職人の世界はとても厳しく、一人前になるにも15年はかかります。就職活動を辞めて「弟子入りさせてください」という彼を最初は断わりましたが、彼の熱意に押されて受け入れることにしました。越本くんも、世界に通用する技術を身につけるために「墨流し」という技法をアレンジした「流彩染め」という必殺技を編み出しているところです。'
      ]
    ]
    images: [
      '/assets/image/africadogs/nishida_11.png'
      '/assets/image/africadogs/nishida_9.png'
      '/assets/image/africadogs/nishida_13.png'
      '/assets/image/africadogs/nishida_14.png'
      '/assets/image/africadogs/IMG_0230.png'
    ]
    points: [
      'p3-3'
      'p3-4'
      'p3-5'
      'p3-6'
      'p3-7'
    ]
    targetID: -1
  methods:
    showPopup: (id) ->
      @targetID = id
    closePopup: () ->
      @targetID = -1
    addPoint: (point) ->
      @$emit('addPoint', point)
